import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'

/*
 * Header gallery
 */
    Fancybox.bind(`.wp-block-gallery figure a`, {
    groupAll: true,
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },
    Thumbs: {
        type: 'classic',
    },
})
